import { KngShellFactory, KngShellState, ModalState, KngHeaderNavStateItem } from 'kinetic-angular';
import { AemLabelsPolicy, AemLabelsTnC, AssignedRoles, BusinessAccountRegistrationSuccess, CustomerState, MultipleRoleToastMsg } from './shell.interface';
import { Icons, ModalButtonId } from '../../services/shared/shared-enums';
import { SharedFactoryDataService } from '../../services/shared/shared-factory-data.service';
import { KngBannerState, ReviewListBannerState } from 'projects/kinetic-angular/src/lib/components/banner/definitions';

export class ShellFactory
{
	public static buildState(): KngShellState
	{
		const state: KngShellState = KngShellFactory.buildState();
		return state;
	}
	public static buildBannerState(): KngBannerState
	{
		return {
          
			bannerIcon: {
				iconPath: '',
				altText: ''
			},
			bannerMessage: '',
			tokenData: [
				{
					label: '',
					value: '',
					href: ''
				}
			],
			closeIcon: {
				iconPath: '',
				altText: ''
			},
			open: false,
			alertBanner: [],
			startDate: new Date(),
			endDate: new Date()
		};
	}
	public static reviewListBannerState(): ReviewListBannerState
	{
		return {
          
			bannerIcon: {
				iconPath: '',
				altText: ''
			},
			bannerMessage: '',
			closeIcon: {
				iconPath: '',
				altText: ''
			},
			open: false,
			startDate: new Date(),
			endDate: new Date()
		};
	}
	public static buildTnC(): ModalState
	{
		return {
			closeHidden: true,
			hidden: false,
			label: '',
			buttons: [
				{ label: '', disabled: false, cssClass: 'btn-secondary', iconPath: '' },
				{ label: '', iconPath: '', disabled: true, cssClass: 'btn-black' }
			],
			tooltip: {
				closeIcon: {
					iconPath: Icons.toolTipCloseIcon,
					altText: ''
				},
				content: ''
			},
			cssClass: 'register-modal'
		};
	}
	public static buildAEMlist(): AemLabelsTnC
	{
		return {
			updatedTerms: {
				agreeButtonLabel: '',
				heading: '',
				content: [],
				disagreeButtonLabel: '',
				creationDate: 0,
				infoIcon: [{
					iconPath: '',
					    altText: ''
				}],
				checkboxText: '',
				alertNote: ''
			}


		};
	};
	public static buildAEMlistPolicy(): AemLabelsPolicy
	{
		return {
			updatedPrivacy: {
				agreeButtonLabel: '',
				heading: '',
				content: [],
				disagreeButtonLabel: '',
				creationDate: 0,
				infoIcon: [{
					iconPath: '',
					    altText: ''
				}],
				checkboxText: '',
				alertNote: ''
			}


		};
	};
	public static buildPolicy(): ModalState
	{
		return {
			closeHidden: true,
			hidden: true,
			label: '',
			buttons: [
				{ label: '', disabled: false, cssClass: 'btn-secondary', iconPath: '' },
				{ label: '', iconPath: '', disabled: true, cssClass: 'btn-black' }
			],
			tooltip: {
				closeIcon: {
					iconPath: Icons.toolTipCloseIcon,
					altText: ''
				},
				content: ''
			},
			cssClass: 'register-modal'
		};
	}
	public static buildDefaultTranslationValuesMap(): Map<string, string>
	{
		return new Map<string, string>([
			[ 'United States- English', 'en' ],
			[ 'États-Unis - anglais', 'en' ],
			[ 'French', 'fr' ],
			[ 'Français', 'fr' ]
		]);
	}
	public static buildMinimumAccessHaeder(): KngHeaderNavStateItem[]
	{
		const state: KngHeaderNavStateItem[] = KngShellFactory.buildState().header;
		state.forEach(section => 
		{
			section.minimumAccess = true;
		});
		return state;
	}
	public static buildBusinessAccountRegistrationSuccessModal(): BusinessAccountRegistrationSuccess
	{
		return { 
			congratulationsImage: SharedFactoryDataService.buildImage(Icons.congratulations, ''),
			mainText: '',
			subText: '',
			modal: {
				closeHidden: false,
				hidden: true,
				label: '',
				buttons: [
					{ label: '', disabled: false, cssClass: 'btn-black', iconPath: '' }
				],
				cssClass: 'congratulatory-modal'
			}
		};
	}
	public static buildCustomerState(): CustomerState
	{
		return {
			hidden: true,
			username: '',
			warningNote: '',
			readOnly: '',
			endSession: '',
			endSessionNote: '',
			inativityMessage: '',
			inactivityConfirmation: ''
		};
	}
	public static buildEndSessionModal(): ModalState
	{
		return this.dialogState();
	}
	public static buildInactiveSessionModal(): ModalState
	{
		return this.dialogState();
	}
	public static buildReminderModal(): ModalState
	{
		return this.dialogState();
	}
	public static dialogState(): ModalState
	{
		return {
			hidden: true,
			label: '',
			buttons: [
				{ label: '', id: ModalButtonId.cancel, disabled: false, cssClass: 'btn-secondary', iconPath: '' },
				{ label: '', id: ModalButtonId.proceed, iconPath: '', disabled: false, cssClass: 'btn-black' }
			],
			cssClass: ''
		};
	}

	public static buildMultipleRoleModal(): ModalState 
	{
		return this.dialogState();
	}

	public static buildAssignedRoles(): AssignedRoles
	{
		return {
			TMH_CORP_ADMIN: '',
			CUSTOMER_SUPPORT_ROLE: '',
			ACCOUNT_MANAGERROLE: ''
		};
	}

	public static buildMulRoleToastMsg() : MultipleRoleToastMsg
	{
		return {
			corpAdminTstMsg: '',
			csrTstMsg: '',
			accMngTstMsg: ''
		};
	}
}

